'use strict';

import {find, findAll, register} from '../../../../../JavaScript/Utils';

const Item = $el => {
    if ($el.tagName.toLowerCase() !== 'footer') {
        return;
    }

    const footerNavigationItems = findAll('[data-nezzo-footer-dropdown]', $el);

    footerNavigationItems.forEach(item => {
        const toggle = find('[data-nezzo-footer-dropdown-toggle]', item);
        const toggleItem = find('[data-nezzo-footer-dropdown-toggle-item]', item);

        toggle.addEventListener('click', () => {
            toggleItem.classList.toggle('open');
            toggle.classList.toggle('open');
        });
    });
};

register('Footer', Item);
